/**
 * Scheduled Post Dialog for scheduling a post
 *
 * @author Paige Ponzeka (pponzeka@yext.com)
 */
goog.module('yext.social.scheduledpostdialog');
goog.module.declareLegacyNamespace();


function init() {
  return new ScheduledPostDialog();
}

/**
* Scheduled Post Dialog
* @constructor
*/
var ScheduledPostDialog = function(options) {
  // TODO(i18n) Date/time format
  this.options = $.extend(true, {}, this.defaults, options);
  this.$dialog = $('#schedule-post-dialog');
  // make sure the dialog exists
  if (this.$dialog.length > 0) {
    this.$container = this.$dialog.closest('.fb-post-box-container');
    this.$hiddenInput = this.$container.find('#scheduledPostDate');
    this.btnDefaultText = this.$container.find('.js-schedule-post-text').html();
    this.userTimeZone = window.jstz.determine().name();
    this.selectedTimezoneOffset = this.$container.find('.js-tz-selector option:selected').data('offset');
    // Using userTimeZone as the default destinationTimeZone
    this.destinationTimeZone = this.userTimeZone;
    this.dialogTimePicker = this.$dialog.find('.js-user-timepicker');
    this.dialogDatePicker = this.$dialog.find('.js-date-picker-container');
    this.defaultMinTime = '12:00am';
    this.defaultMaxTime = '11:30pm';
    this.validTimeRegex = /^(10|11|12|[1-9]):[0-5][0-9](a|p)m$/;
    this.initTimePicker();
    this.initDatePicker();
    this.bindActions();
    this.dateSelected = new Date(); // defaults selected date to today
    this.setSelectedDatetime();
  }
};

/**
 * Intializes the TimePicker, sets the default times and the ranges
 */
ScheduledPostDialog.prototype.initTimePicker = function() {
  var self = this;
  var startTime = self.getInitTimePickerTime();
  var opts = {
    timeFormat: 'hm',
    scrollDefault: true,
    minTime: this.defaultMinTime,
    forceRoundTime: false,
    maxTime: self.defaultMaxTime,
  };

  self.dialogTimePicker.timepicker(opts);
  self.dialogTimePicker.timepicker('setTime', startTime);
  self.dialogTimePicker.on('changeTime', function() {
    self.setSelectedDatetime();
    self.validateFutureDate();
  });

  // set timezone based on user's timezone
  var $selectOptions = self.$dialog.find('.js-tz-selector');
  if (self.$dialog.find('.js-tz-selector option[value=\''+ self.destinationTimeZone+ '\']').length !== 0) {
    $selectOptions.val(self.destinationTimeZone);
  } else {
    $selectOptions.append($('<option></option>')
      .attr('value', self.destinationTimeZone)
      .attr('selected', 'selected')
      .text($selectOptions.data('map')[self.destinationTimeZone]));
  }
};

/**
 * Intializes the Date Picker, adds onSelect listener
 * @suppress {deprecated}
 */
ScheduledPostDialog.prototype.initDatePicker = function() {
  var self = this;

  self.dialogDatePicker.datepicker({
    minDate: new Date(), // set minDate to today (No Posts scheduled in the past)
    onSelect: function() {
      self.setSelectedDatetime();
      self.validateFutureDate();
      // check if set date is today (if so update the timepicker ranges accordingly)
      var setDate = self.dialogDatePicker.datepicker('getDate');
      var today = new Date();
    },
  });
};

/**
 * Bind Dialog Event Listeners
 */
ScheduledPostDialog.prototype.bindActions = function() {
  var self = this;
  self.$dialog.find('.js-schedule-apply-btn').on('click', function() {
    if (!$(this).hasClass('btn-disabled')) {
      self.schedulePostApply();
    }
  });

  self.$dialog.find('.js-schedule-cancel-btn').on('click', function() {
    self.hideDialog();

    self.$container.find('.js-schedule-post-text').html(self.btnDefaultText);
    self.$hiddenInput.val('');
  });

  self.$dialog.find('.js-user-timepicker').on('keyup paste', function() {
    if (self.validateTimeInput($(this).val())) {
      self.setSelectedDatetime();
      self.validateFutureDate();
    }
  });

  self.$dialog.find('.js-tz-selector').on('change', function() {
    self.selectedTimezoneOffset = $('option:selected', this).data('offset');
    self.validateFutureDate();
  });
};

/**
 * Show the Dialog
 */
ScheduledPostDialog.prototype.showDialog = function() {
  this.$dialog.slideDown();
  var self = this;

  // close the dialog when clicking outside of it
  $(window).bind('click.scheduledPostDialog', function(e) {
    if (e.type == 'click' && ($(e.target).parents('#schedule-post-dialog').length === 0)
      // the timepicker ui does not see this as a parent
      && !$(e.target).hasClass('ui-timepicker-selected')
      // the datepick ui does not see this as a parent either
      && !$(e.target).hasClass('ui-icon-circle-triangle-e')
      && !$(e.target).hasClass('ui-icon-circle-triangle-w')) {
      self.hideDialog();
    }
  });
};

/**
 * Hide the dialog
 */
ScheduledPostDialog.prototype.hideDialog = function() {
  this.$dialog.slideUp();
  this.$container.removeClass('fb-post-box-container-schedule');

  this.$container.find('.js-schedule-post-btn').removeClass('btn-active');
  this.$container.find('.js-schedule-clock').removeClass('icon-clock-white').addClass('icon-clock');

  $(window).unbind('click.scheduledPostDialog');
};

/**
 * Returns now + 30 min in a string format friendly to the timepicker plugin
 * (i.e. 12:00pm)
 */
ScheduledPostDialog.prototype.getInitTimePickerTime = function() {
  var startTime = new Date();
  startTime.setMinutes(startTime.getMinutes() + 30);
  var currentHours = startTime.getHours();
  var ampm = currentHours >= 12 ? 'pm' : 'am';
  var currentMinutes = (startTime.getMinutes() - 30 < 0) ? '00' : '30';
  currentHours = currentHours % 12;
  currentHours = currentHours ? currentHours : 12; // the hour '0' should be '12'
  return currentHours + ':' + currentMinutes + ampm;
};

/**
 * Toggled the disabled state of the dialog (button and warning message)
 * @param {boolean} isDisabled if true disabled the dialog otherwise leave it
 */
ScheduledPostDialog.prototype.toggleDisabled = function(isDisabled) {
  this.$dialog.find('.js-future-error-block').toggle(isDisabled);
  this.$dialog.find('.js-schedule-apply-btn').toggleClass('disabled btn-disabled', isDisabled);
};

/*
 * Makes sure the selected time is in the future, if it isn't it disabled the 'Schedule' button and shows a warning
 */
ScheduledPostDialog.prototype.validateFutureDate = function() {
  // since there's no way to convert between timezones without a plugin
  // and we can't currently use a timezone plugin atm we're going to have
  // to fake it

  // today is going to be in the browsers local time so we are going to get the
  // local browsers offset and subtract that from the user's selected timezone's
  // offset to make sure the date is ACTUALLY in the future


  // So GMT-4 returns .getTimezoneOffset() = +240 (minutes) while we get -240
  // from the select box, we're just going to manually offset that here
  var today = new Date();
  var dateSelected = this.dateSelected;
  var millsecondsInMinute = 60000;
  var todayAsMilliseconds = today.getTime();
  var updatedDateAsMilliseconds = dateSelected.getTime();
  var localOffset = -(today.getTimezoneOffset() * millsecondsInMinute);
  var dateSelectOffset = parseInt(this.selectedTimezoneOffset);
  var timeDifference = localOffset - dateSelectOffset;

  // check to see if we even need to do anything to adjust the times
  if (timeDifference != 0) {
    updatedDateAsMilliseconds += timeDifference;
  }

  // update the display if the user's selected datetime is in the future
  this.toggleDisabled(updatedDateAsMilliseconds < todayAsMilliseconds);
};

/*
 * Button action for 'Schedule' dialog Action (process dialog)
 */
ScheduledPostDialog.prototype.schedulePostApply = function() {
  this.hideDialog();
  this.setSelectedDatetime();
  // TODO(i18n) Date/time format
  var dateFormat = $.datepicker.formatDate('MM dd, yy', this.dateSelected);
  var hours = this.dateSelected.getHours() % 12;
  hours = (hours == 0 ? 12 : hours);
  var minutes = this.dateSelected.getMinutes();
  if (minutes < 10) {
    minutes = '0'+minutes;
  }
  var ampm = this.dateSelected.getHours() < 12 ? 'AM' : 'PM';

  dateFormat += ' '+hours+':'+minutes+ampm;

  this.$container.find('.js-schedule-post-text').html(dateFormat);
  this.$hiddenInput.val(this.dateSelected.getTime());
};

/**
 * Combines the set time and date from the date and time picker in the dialog
 * @suppress {deprecated}
 */
ScheduledPostDialog.prototype.setSelectedDatetime = function() {
  var date = this.dialogDatePicker.datepicker('getDate');
  var time = this.dialogTimePicker.timepicker('getTime');
  this.dateSelected = new Date(date.getFullYear(), date.getMonth(), date.getDate(),
    time.getHours(), time.getMinutes(), time.getSeconds());
  this.destinationTimeZone = this.$dialog.find('.js-tz-selector').val();
};

ScheduledPostDialog.prototype.resetSchedule = function() {
  this.$container.find('.js-schedule-post-text').html(this.btnDefaultText);
  this.$hiddenInput.val('');
};

ScheduledPostDialog.prototype.validateTimeInput = function(input) {
  return this.validTimeRegex.test(input);
};


exports = {
  init,
};
